module.exports = __webpack_public_path__ + "img/18_Middle-rectrum.200af8dc.png";